/**
 * The isInterfaceOf returns a boolean indicating if the model matches an interface
 *
 * @param {TModel} model object to do the type check on
 * @param {keyof TModel} property a unique property that exist only in TModel
 * @returns {model is TModel}
 *
 * @example
 * const animal: Bird | Fish = {
 * 	//
 * };
 *
 * if (isInterfaceOf<Bird>(animal, "fly")) {
 * 	// its a Bird
 * } else {
 * 	// its a Fish
 * }
 */
export function isInterfaceOf(model, property) {
    return model && property in model;
}
